<template>
  <section class="hero">
    <div class="hero__cover">
      <AppPicture
        class="hero__picture"
        :data="{ url: data.image }"
        :isLazy="false"
      />

      <div class="c-container">
        <h2 class="hero__title" v-html="data.title">
        </h2>
      </div>
    </div>

    <div class="hero__content">
      <div class="c-container">
        <AppTextBlock
          class="hero__description"
          ref="heroWhere"
          v-if="data.description !== undefined"
          :data="{ title: data.subtitle, content: data.description }"
          :isAnimated="false"
        />

        <aside class="hero__spec">
          <AppTextBlock
            ref="heroWhere"
            v-if="data.where !== undefined"
            :data="{ content: data.where, title: 'Where' }"
            :isAnimated="false"
          />
          <AppTextBlock
            ref="servicesWhere"
            v-if="data.services !== undefined"
            :data="{ content: data.services, title:'Services' }"
            :isAnimated="false"
          />
        </aside>
      </div>
    </div>
  </section>
</template>

<script>
import TimelineLite from 'gsap/TimelineLite';
import { Power4 } from 'gsap/EasePack';
import title from '@/scripts/animations/title';
import paragraph from '@/scripts/animations/paragraph';
import { qs } from '@/scripts/utils';

import AppPicture from '@/components/AppPicture.vue';
import AppTextBlock from '@/components/AppTextBlock.vue';


export default {
  name: 'hero',

  components: {
    AppPicture,
    AppTextBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.enterAnimation();
  },

  methods: {
    enterAnimation() {
      const space = window.innerWidth < 1024 ? 100 : 0;
      const calcPerc = (qs('.hero__title', this.$el).getBoundingClientRect().height + space)
        * 100 / qs('.hero__picture', this.$el).getBoundingClientRect().height;
      const tl = new TimelineLite({ delay: 1.5 });

      tl.addLabel('start')
        .fromTo('.hero__picture', 2, {
          height: '100%',
        }, {
          height: `${100 - calcPerc}%`,
          overflow: 'hidden',
          ease: Power4.easeOut,
        }, 'start')
        .to('.hero__picture div', 1, {
          scale: 1.2,
          ease: Power4.easeOut,
        }, 'start')
        .add(title(qs('.hero__title', this.$el)), 'start+=1')
        .add(paragraph(qs('.hero__description', this.$el)), 'start+=1.4')
        .add(title(qs('h4', this.$refs.heroWhere.$el)), 'start+=1.6')
        .add(paragraph(qs('p', this.$refs.heroWhere.$el)), 'start+=2')
        .add(title(qs('h4', this.$refs.servicesWhere.$el)), 'start+=1.6')
        .add(paragraph(qs('p', this.$refs.servicesWhere.$el)), 'start+=2');

      if (window.innerWidth < 1024) tl.to('.hero__cover', 1, { height: '50vw', ease: Power4.easeOut }, 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';
@import '../style/mixins';

.hero {
  position: relative;
  width: 100%;

  box-sizing: border-box;

  &__cover {
    position: relative;
    height: 100vh;
    width: 100%;

    display: flex;
    align-items: flex-end;
    justify-content: flex-start;

    .c-container {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &__picture {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    z-index: 5;
  }

  &__title {
    font-size: font-size(title);
    -webkit-text-stroke: 2px $color-text;
    letter-spacing: 1px;
    color: transparent;
    margin-bottom: -2%;

    @include mq($until: ipadP) {
      -webkit-text-stroke: 1px $color-text;
      font-size: font-size(xxxl);
    }
  }

  &__content {
    position: relative;

    .c-container {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-flow: row wrap;
    }
  }

  &__description {
    width: 100%;
    flex: 0 0 100%;

    @include mq(ipadL) {
      width: 55%;
      flex: 0 0 55%;
    }
  }

  &__spec {
    width: 100%;
    flex: 0 0 100%;
    padding-top: 40px;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    @include mq(ipadL) {
      flex: 0 0 auto;
      width: auto;
      padding-top: 0;
    }

    & div:last-child {
      margin-left: 60px;
    }
  }
}
</style>
<style>
.hero .hero__cover .picture__image-bg {
  background-position: center bottom;
}
</style>
